import { extractKeyValuePairs } from "encamp-omnisearch/src/utils/util";

export type TaskStatusFilterKey = "status" | "taskStatus";

const STATUS_KEYS: readonly string[] = ["status", "taskStatus"] satisfies TaskStatusFilterKey[];

/** Statuses the task lists show when no status filter is picked. */
export const LIST_DEFAULT_TASK_STATUSES = "OPEN|IN_PROGRESS";
/** Calendar default: every status except canceled. */
export const CALENDAR_DEFAULT_TASK_STATUSES = "OPEN|IN_PROGRESS|COMPLETED";
/** Every task status. The All Tasks chip and its count use this. */
export const ALL_TASK_STATUSES = "OPEN|IN_PROGRESS|COMPLETED|CANCELED";

/**
 * Replace any existing `status`/`taskStatus` token with a single new
 * key:value (or remove both if `nextKey` is null). Returns the rebuilt
 * omnisearch string. The status filter buttons are mutually exclusive, so
 * we compute the next state atomically rather than via two sequential
 * mutations (which both read a stale closure of the current value).
 */
export function replaceStatusFilter(
  omnisearch: string,
  nextKey: TaskStatusFilterKey | null,
  nextValue: string | null
): string {
  const pairs = extractKeyValuePairs(omnisearch);
  const tokens: string[] = [];
  for (const pair of pairs) {
    if (STATUS_KEYS.includes(pair.key)) continue;
    tokens.push(omnisearch.slice(pair.start, pair.end));
  }
  if (nextKey && nextValue) {
    tokens.push(`${nextKey}:${nextValue}`);
  }
  return tokens.join(" ").trim();
}
